import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DocStereoTypeDto, DocStereoTypesDto, GenericDocumentData } from 'projects/shared/src/lib/models/DocStereoTypeDto';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { SquirrelSessionRequest } from 'projects/shared/src/lib/models/SquirrelSession';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectService } from 'projects/shared/src/lib/services/project.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';


import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
//import 'ag-grid-community/dist/styles/ag-grid.css';
//import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { UserProjectsButtonRendererComponent } from 'projects/user/src/lib/project-list/user-projects-button-renderer/user-projects-button-renderer.component';
import { Observable } from 'rxjs';
import { ProjectGroupRolePermissionService } from 'projects/shared/src/lib/services/project-group-role-permission.service';
import { AgGridUserProjectsSettings } from './AgGridUserProjectsSettings';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { EventsService } from 'projects/shared/src/lib/services/events.service';
import { SquirrelManagementService } from 'projects/shared/src/lib/services/squirrel-management.service';
import { UserProjectsImageRendererComponent } from './user-projects-image-renderer/user-projects-image-renderer.component';


@Component({
  selector: 'project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectListComponent implements OnInit {

  _db:string = "";

  squirrelSessionRequest!: SquirrelSessionRequest;

  selectedRow: any;
  selectedRows!: number;

  project!: ProjectDto;

  docStereoTypesDto!: DocStereoTypesDto;
  docStereoTypeDto!: DocStereoTypeDto;
  docStereoTypeDtos!: DocStereoTypeDto[];

  docStType$!: Observable<DocStereoTypeDto[] | undefined>;

  genericDocumentData!: GenericDocumentData;

  rowData: ProjectDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  components: any;
  filter!: GenericFilter;
  sq_spinner: any = './assets/img/sq-spinner.gif';

  agGridUserProjSettings!: AgGridUserProjectsSettings
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  //resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  constructor(public translate: TranslateService,
    private oauthService: OAuthServiceService,
    private projectService: ProjectService,
    private dataSharingService: DataSharingService,
    private notificationService: NotificationService,
    private projectGroupRolePermissionsService: ProjectGroupRolePermissionService,
    private tenantService: TenantService,
    private eventsService:EventsService,
    private managementService: SquirrelManagementService,
    ) { }

  ngOnInit(): void {

    //console.log("-----------> project-list")

    this.squirrelSessionRequest = new SquirrelSessionRequest();

    this.filter = new GenericFilter();
    this.agGridUserProjSettings = new AgGridUserProjectsSettings(this.translate);
    this.frameworkComponents = { buttonRenderer: UserProjectsButtonRendererComponent, imageRenderer: UserProjectsImageRendererComponent }
    this.gridOptions = this.agGridUserProjSettings.agGridUserProjectsSettings;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          //console.log("-----------> project-list: user roles = ", userRoles)
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
              this._db = dbrole;
              }
          });
        }
      }
    });

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'Project';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        //console.log("-----------> project-list: dbrole = ", this._db)
        // if(this._db)
        // {
        let db:string = this.tenantService.currentTenantName;

        this.tenantService.getUserProjects(this.filter, db).subscribe({
        //this.projectService.loadProjectGeoData(this.filter).subscribe({
          next: (data: any) => {
            this.rowData = data.slice(this.filter.startRow, this.filter.endRow);
            this.dataSharingService.passGeoData(data.item2);

            let lastRow = -1;

            if (this.rowData.length <= this.filter.endRow) {
              lastRow = this.rowData.length;
            }
            params.successCallback(this.rowData, lastRow);
            // Flip flag to show that loading has finished.
            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            //this.resultsLength = this.rowData.length;

            this.gridApi.hideOverlay();

            if (this.rowData.length > 0) {
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["PROJECTSRETRIEVED"]}`);
            }
            else {
              this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOPROJECTSRETRIEVED"]}`);
            }  
          },
          error: () => {
            this.isLoadingResults = false;
            // Catch if the Squirrel API has reached its rate limit. Return empty data.
            this.isRateLimitReached = true;
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTRETRIVALERROR"]}`)
          }
        });
      }
        // else
        // {
        //   let db:string = this.tenantService.currentTenantName;
        //   this.tenantService.getUserProjects(this.filter, db).subscribe({
        //     next: (data) => {
        //       this.rowData = data.slice(this.filter.startRow, this.filter.endRow);
        //       let lastRow = -1;
  
        //       if (this.rowData.length <= this.filter.endRow) {
        //         lastRow = this.rowData.length;
        //       }
        //       params.successCallback(this.rowData, lastRow);
  
        //       this.isLoadingResults = false;
        //       this.isRateLimitReached = false;
        //       this.resultsLength = this.rowData.length;
  
        //       this.gridApi.hideOverlay();
  
        //       //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["PROJECTSRETRIEVED"]}`);
        //     },
        //     error: (error: any) => {
        //       this.isLoadingResults = false;
        //       // Catch if the Squirrel API has reached its rate limit. Return empty data.
        //       this.isRateLimitReached = true;
        //       this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTRETRIVALERROR"]}`)
        //     }
        //   });
        // }
      // }
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds);
  }
  

  onRowClicked($event: any) {
    console.log("--------> project-list event = ", $event)

    const rowData = [$event.node.data];

    let db:string = this.tenantService.currentTenantName;
    this.managementService.GetSq3ProjectAuthentification(db, rowData[0].id).subscribe({ 
      next: (projAuth) => {
        console.log("-------> project-list Project Url: ", `${projAuth.frontendurl}/Modell/?frontendkey=${projAuth.frontendkey}`);
        window.open(`${projAuth.frontendurl}/Modell/?frontendkey=${projAuth.frontendkey}`, '_blank');
      },
      error: () => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "management project authentication error")
      }
    })

    // this.store.dispatch(docStTypesActions.invokeGenericDocumentsApi({ dbname: $event.node.data.name }));
    // this.store.dispatch(projectSesssionActions.invokeApis({projectname:$event.node.data.name}));

    this.dataSharingService.passProjectUrl($event.node.data.url);

    //localStorage.setItem('dbname', $event.node.data.name);
    //localStorage.setItem('project_id', $event.node.data.id);
    this.tenantService.projectId = this.project.id;

    // if(this._db){
    //   this.projectGroupRolePermissionsService.getProjectUserPermissions($event.node.data.id).subscribe({
    //     next: (permissions: string[]) => {
    //       this.squirrelSessionRequest.projectPermissions = permissions
    //     }
    //   });
    // }
    // else{
      
    
      // TODO hier muss PROJECTGROUPROLES von der Tenant DB gelesen werden und die Permissions ermittelt werden
      // let db:string = this.tenantService.currentTenantName;
      // this.tenantService.getProjectUserPermissions($event.node.data.id, db).subscribe({
      //   next: (permissions: string[]) => {
      //     this.squirrelSessionRequest.projectPermissions = permissions
      //   }
      // });
      
    // }

    this.squirrelSessionRequest.languageKey = localStorage.getItem('app_lang') as string;
    this.squirrelSessionRequest.projectGuid = $event.node.data.id;
    this.squirrelSessionRequest.projectUrl = $event.node.data.url;
    this.squirrelSessionRequest.projectUserGroups = [];

    //this.createSession(this.squirrelSessionRequest)

    // this.dataSharingService.changeSquirrelSessionRequest(this.squirrelSessionRequest);
    // this.dataSharingService.passactiveProjectName($event.node.data.name);
    // this.dataSharingService.passactiveProjectId($event.node.data.id);
  }

  onRowSelected($event: any) { }

//   createSession(squirrelSessionRequest: SquirrelSessionRequest) {
//     squirrelSessionRequest.languageKey = localStorage.getItem('app_lang') as string;

//     console.log("-------> project-list: createSession() - squirrelSessionReq", squirrelSessionRequest)

//     this.projectService.createProjectSession(squirrelSessionRequest).subscribe({
//       next: (sqSession) => {
//         console.log(sqSession)
//         this.notificationService.success(`${this.translate.data["CREATESQUIRRELSESSION"]}`, `${this.translate.data["SQUIRRELSESSIONCREATED"]}`);
// //        this.projectUrl = '';
//         window.open(`${sqSession.legacySquirrelUrl}`, '_blank');
//       },
//       error: () => {
//         this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["CREATESQUIRRELSESSIONERROR"]}`)
//       }
//     })
//   }

}
